const ACTIONS_REPORT_RECIPIENT = {
  INVALIDATE: 'REPORT_RECIPIENTS_INVALIDATE',
  RECEIVE: 'REPORT_RECIPIENTS_RECEIVE',
  DELETE: 'REPORT_RECIPIENT_DELETE',
  UPDATE: 'REPORT_RECIPIENT_UPDATE',
};

export default ACTIONS_REPORT_RECIPIENT;
